import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import KiffrAtbForm from "components/source/pdp/kiffr-atb-form";
import AtomRetailPrice from "../atoms/atom-retail-price";
import { useUserData } from "components/source/hoc/with-user-data";
import { isSubscriptionMember } from "helpers/membership-helpers";
import { useMembershipState } from "components/layout/MembershipStateContext";
import MembershipPickWayfind from "components/source/membership/membership-pick-wayfind";
import { navigateTo } from "helpers/location-helpers";
import ShippingAndReturns from "components/source/pdp/shipping-and-returns.jsx";
import PromoExclusion from "../products/promo-exclusion";
import { flagsAndExperimentNames } from "rtr-constants";

const KiffrAtbContainerComponent = ({ product, children, preSelectedSku }) => {
  const userData = useUserData();
  const basePathUrl = useSelector(state => state.basePath);
  const basePathDrawer = useSelector(state => state.gridProductDrawer?.pdpUrl);
  const promoExclusionFlag = useSelector(
    state => state.flagsAndExperiments?.[flagsAndExperimentNames.CATALOG_SERVICES_SHOW_PROMO_EXCLUSION]
  );
  const staticProduct = useSelector(state => state.staticProduct);
  const basePath = basePathDrawer || basePathUrl;
  const { membershipState } = useMembershipState();

  const exitCTACopy = isSubscriptionMember(userData)
    ? KiffrAtbContainerComponent.subscriberCopy(basePath, product, userData, membershipState)
    : KiffrAtbContainerComponent.defaultCopy(basePath);

  return (
    <div className="kiffr-atb-container" data-test-id="kiffr-atb-container">
      <div className="kiffr-atb-container__details">
        <div key="price" className="universal-large">
          <span className="purchase-price pricing-divider">
            <AtomRetailPrice
              designerId={product?.designer?.id}
              showPurchasePrice={true}
              showPurchasePriceDiscount={true}
              hideRetailValue={true}
              supressRetailValueCopy={true}
              purchasePrice={product?.purchasePrice}
              product={product}
              retailPrice={product?.retailPrice}
            />
          </span>
        </div>
      </div>
      {promoExclusionFlag && staticProduct?.merchandisingCategory === "Rental" && (
        <PromoExclusion shouldExclude={staticProduct && staticProduct?.styleoutYear === "2025"} />
      )}
      <div className="kiffr-atb-container__add-to-bag">
        <KiffrAtbForm
          preSelectedSku={preSelectedSku}
          sizeNames={product.sizeScale.sizeNames}
          skus={product.skus}
          userData={userData}
          product={product}>
          {children}
        </KiffrAtbForm>
      </div>
      <p className="kiffr-atb-container__exit-cta">{exitCTACopy}</p>
      <div className="returns-copy">
        <ShippingAndReturns product={product} hasAddress={!!membershipState?.address} />
      </div>
    </div>
  );
};

KiffrAtbContainerComponent.defaultCopy = basePath => (
  <a className="underline default-copy" href={basePath}>
    Or, Browse to Rent
  </a>
);
KiffrAtbContainerComponent.subscriberCopy = (basePath, product, userData, membershipState) => (
  <>
    <MembershipPickWayfind
      handleWayfindCtaClick={() => navigateTo(`${basePath}?lens=unlimited`)}
      membershipState={membershipState}
      product={product}
      userData={userData}
      manuallyShowOption="membership"
    />
    <MembershipPickWayfind
      handleWayfindCtaClick={() => navigateTo(`${basePath}?lens=classic`)}
      membershipState={membershipState}
      product={product}
      userData={userData}
      manuallyShowOption="reserve"
    />
  </>
);
KiffrAtbContainerComponent.propTypes = {
  children: PropTypes.element,
  preSelectedSku: PropTypes.string,
  product: PropTypes.shape({
    id: PropTypes.string,
    designer: PropTypes.shape({
      id: PropTypes.string,
    }),
    purchasePrice: PropTypes.string,
    retailPrice: PropTypes.string,
    sizeScale: PropTypes.shape({
      sizeNames: PropTypes.object,
    }),
    skus: PropTypes.array,
    urlHistory: PropTypes.array,
  }),
};

export default KiffrAtbContainerComponent;
